<script>
  import Router from 'svelte-spa-router'

  import Navbar from './components/Navbar.svelte'
  import Home from './views/Home.svelte'
  import Solutions from './views/Solutions.svelte'
  import Contact from './views/Contact.svelte'
  import Footer from './components/Footer.svelte'

  const routes = {
    '/': Home,
    '/solutions': Solutions,
    '/contact': Contact,
    '*': Home
  }
</script>

<main>
  <Navbar />
  <Router {routes} />
  <Footer />
</main>

<style>
  main {
    text-align: center;
    margin: 0 auto;
  }
</style>
